export class OfflineCheck {

    downloadId: number;
    available: boolean;
    url: string;

}
